import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'

export const clearSelection = createActionCreator(actions.CLEAR_SELECTION)

export const removeSelected = createActionCreator(actions.REMOVE_SELECTED, 'id')

export const togglePolygonMode = createActionCreator(actions.TOGGLE_POLYGON_MODE)

export const selectWithPolygon = createActionCreator(actions.SELECT_WITH_POLYGON, 'polygon')

export const toggleStompunkt = createActionCreator(actions.TOGGLE_STOMPUNKT, 'id')

export const toggleCurrentStompunkt = createActionCreator(actions.TOGGLE_CURRENT_STOMPUNKT)



// WEBPACK FOOTER //
// ./src/actionCreators/selection.js